const state = {
  PendingDeposit: 0,
  PendingWithdrawal: 0,
  PendingPromotion: 0,
  PendingAutoDepositPlus: 0
}
const getters = {
  getPendingDeposit: state => {
    return state.PendingDeposit
  },
  getPendingWithdrawal: state => {
    return state.PendingWithdrawal
  },
  getPendingPromotion: state => {
    return state.PendingPromotion
  },
  getPendingAutoDepositPlus: state => {
    return state.PendingAutoDepositPlus
  }
}
const mutations = {
  setPendingDeposit(state, value) {
    state.PendingDeposit = value
  },
  setPendingWithdrawal(state, value) {
    state.PendingWithdrawal = value
  },
  setPendingPromotion(state, value) {
    state.PendingPromotion = value
  },
  setPendingAutoDepositPlus(state, value) {
    state.PendingAutoDepositPlus = value
  }
}
const actions = {
  setPendingDeposit({commit}, value) {
    commit('setPendingDeposit', value)
  },
  setPendingWithdrawal({commit}, value) {
    commit('setPendingWithdrawal', value)
  },
  setPendingPromotion({commit}, value) {
    commit('setPendingPromotion', value)
    },
  setPendingAutoDepositPlus({ commit }, value) {
    commit('setPendingAutoDepositPlus', value)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/DashboardData.js